<template>
  <div class="mobile-home">
    <Banner />
    <Feature />
    <Testimonial />
    <Partner />
  </div>
</template>

<script>
import Banner from './Banner.vue';
import Feature from './Feature.vue';
import Testimonial from './Testimonial.vue';
import Partner from './Partner.vue';

export default {
  name: 'Home',
  components: {
    Banner,
    Feature,
    Testimonial,
    Partner,
  },
};
</script>
<style>
.mobile-home section {
  margin-bottom: 60px;
}
.mobile-home section .section-caption {
  font-family: "GothamBold";
  font-size: 28px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 40px;
  letter-spacing: normal;
  margin-bottom: 40px;
  color: #5e51a1;
}
</style>
